import React from "react";
import { FlatList, View, StyleSheet, ListRenderItem } from "react-native";
import color from "@constants/color";

interface SkeletonLoaderListProps {
  length: number;
  isLoading?: boolean;
  marginHorizontal?: number;
}

const SkeletonLoaderList: React.FC<SkeletonLoaderListProps> = ({
  length,
  isLoading = true,
  marginHorizontal = 0,
}) => {
  if (!isLoading) return null;

  const skeletonArray = Array.from({ length }, (_, index) => index);

  const renderItem: ListRenderItem<number> = () => (
    <View style={[{ marginHorizontal }, styles.skeletonItem]} />
  );

  return (
    <FlatList
      data={skeletonArray}
      renderItem={renderItem}
      keyExtractor={(item) => item.toString()}
      contentContainerStyle={styles.skeletonContainer}
      showsVerticalScrollIndicator={false}
    />
  );
};

export default SkeletonLoaderList;

const styles = StyleSheet.create({
  skeletonContainer: {
    paddingVertical: 8,
  },
  skeletonItem: {
    height: 60,
    backgroundColor: color.lightGrey,
    borderRadius: 4,
    marginVertical: 8,
  },
});
